module.exports = __webpack_public_path__ + "static/media/close.803fc8ea.svg";